import type { WaterDensityPwCalculator } from "../d";
import { calculateSaltConcentration } from "../spiveyEtAl/helpers";
export const waterDensityPwCalculator: WaterDensityPwCalculator = params => {
  const { salinity_ppm, waterVolumeFactorBBLSTB, waterSpecificGravity } =
    params;

  // N34: =C7/1000000
  const salinty = calculateSaltConcentration(salinity_ppm);

  // N36: =62.368+0.138603*N34+(1.60074*10^-3)*(N34)^2
  const saltWaterDensityAtSurface =
    62.368 + 0.138603 * salinty + 1.60074 * 10 ** -3 * salinty ** 2;

  // N38: =(C10*N36)/H8
  const waterDensityLBMFT3 =
    (saltWaterDensityAtSurface * waterSpecificGravity) /
    waterVolumeFactorBBLSTB;

  return {
    waterDensityLBMFT3,
    salinty,
    saltWaterDensityAtSurface
  };
};
